module.exports = __webpack_public_path__ + "static/media/oussema.5cb220e9.webp";